import {
  Component,
  input,
  computed,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';

export type SoBadgeColor = 
  | 'primary' 
  | 'secondary' 
  | 'success' 
  | 'danger' 
  | 'warning' 
  | 'info'
  | 'grey'
  | 'primary-light'
  | 'secondary-light'
  | 'success-light'
  | 'danger-light'
  | 'warning-light'
  | 'info-light'
  | 'grey-light';

export type SoBadgeColors = { text: string, background: string };

export type SoBadgeSize = 'xs' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'so-badge-ui',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './so-badge.component.html',
  styleUrl: './so-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoBadgeUI {
  text = input.required<string | number>();
  color = input<SoBadgeColor>('primary');
  colors = input<SoBadgeColors | undefined>(undefined);
  size = input<SoBadgeSize>('sm');
  outline = input<boolean>(false);
  pill = input<boolean>(true);
  icon = input<string>('');
  iconPosition = input<'left' | 'right'>('left');
  customClass = input<string>('');

  protected badgeClass = computed(() => {
    const classes: string[] = ['so-badge'];
    
    // Color class
    const colorValue = this.color();
    if (this.outline()) {
      classes.push(`so-badge--outline-${colorValue}`);
    } else {
      classes.push(`so-badge--${colorValue}`);
    }
    
    // Size class
    classes.push(`so-badge--${this.size()}`);
    
    // Pill class
    if (this.pill()) {
      classes.push('so-badge--pill');
    }
    
    // Custom class
    const custom = this.customClass();
    if (custom) {
      classes.push(custom);
    }
    
    return classes.join(' ');
  });

  protected hasIcon = computed(() => !!this.icon());
  protected isIconLeft = computed(() => this.iconPosition() === 'left');
}
